import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthUserInfo, IThirdUserInfo } from 'data/storage';
import { Loading, LoadingStatus } from 'type/http';

type InitialState = {
  // 登录loading
  loading: Loading;
  csrfToken: string;
  error: boolean;
  disabledCaptcha: boolean;
  passwordLogin: {
    btnLoading: boolean;
    isUserRegistered: boolean;
    graphicCaptchaUrl: string;
    passwordError: string;
    graphicCaptchaError: string;
  };
};

const initialState = {
  loading: '',
  csrfToken: '',
  error: false,
  disabledCaptcha: false,
  passwordLogin: {
    btnLoading: false,
    isUserRegistered: true,
    graphicCaptchaUrl: '',
    passwordError: '',
    graphicCaptchaError: ''
  }
} as InitialState;

const login = createSlice({
  name: 'login',
  initialState: initialState,
  reducers: {
    loginByMobilePending(state) {
      state.loading = LoadingStatus.PENDING;
      state.error = false;
    },
    loginByMobileFulfilled(state) {
      state.loading = LoadingStatus.FULFILLED;
    },
    loginByMobileRejected(state) {
      state.loading = LoadingStatus.REJECTED;
      state.error = true;
    },
    resetLoginStatus(state) {
      state.loading = '';
      state.error = false;
      state.disabledCaptcha = false;
    },
    setCsrfToken(state, action: PayloadAction<string>) {
      state.csrfToken = action.payload || '';
    },
    setPasswordLoginData(state, action: PayloadAction<Partial<InitialState['passwordLogin']>>) {
      state.passwordLogin = { ...state.passwordLogin, ...action.payload };
    },
    setGraphicCaptchaUrl(state, action: PayloadAction<string>) {
      state.passwordLogin.graphicCaptchaUrl = action.payload;
    }
  }
});

export default login.reducer;

export const getCode = createAction<string>('login/getCode');
export const getCsrfToken = createAction('login/getCsrfToken');
export const getWeChatToken = createAction('login/getWeChatToken');
export const getWxLoginConfig = createAction('login/getWxLoginConfig');
export const loginByMobile = createAction<{ mobileCaptcha: string; mobile: string; sessionId: string }>('login/loginByMobile');
export const loginByWorkChat = createAction('login/loginByWorkChat');
export const loginByPassword = createAction<{ username: string; password: string; sessionId: string; graphicCaptcha: string }>('login/loginByPassword');
export const loginByResetPassword = createAction<AuthUserInfo>('login/loginByResetPassword');
export const getUserInfoByToken = createAction<string>('login/getUserInfoByToken');
export const loginOut = createAction('login/loginOut');
export const checkUserRegistered = createAction<string>('login/checkUserRegistered');
export const registerByPassword = createAction<any>('login/registerByPassword');
export const refrashGraphicCaptchaUrl = createAction<{ force: boolean }>('login/refrashGraphicCaptchaUrl');
export const afterLogin = createAction<AuthUserInfo>('login/afterLogin');
export const updateUserInfo = createAction<IThirdUserInfo>('login/updateUserInfo');

export const {
  setCsrfToken,
  loginByMobilePending,
  loginByMobileFulfilled,
  loginByMobileRejected,
  resetLoginStatus,
  setPasswordLoginData,
  setGraphicCaptchaUrl
} = login.actions;
